module.exports = __webpack_public_path__ + "img/15.877d9c99.png";